import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';
import { LIBRARY_INCLUDE_ARCHIVED, LIBRARY_NOT_ARCHIVED_FILTERS } from 'components/Grid/libraryFilters';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import ControlActionCell from '../ControlActionCell';

import { CONTROL_FIELD } from '../../constants';
import { ControlRow } from '../../types';

import { basicControlsColumns } from './columns';
import { ControlsTableProps } from './types';

const ControlsTable: React.FunctionComponent<ControlsTableProps> = ({
  onError,
  onRefreshCallback,
}): React.ReactElement => {
  const { routing } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.risks.controlDetails, { entityId: item.id }));
  };

  return (
    <Grid
      basicColumns={
        [
          ...basicControlsColumns,
          {
            field: 'actions',
            type: 'actions',
            headerName: '',
            maxWidth: 50,
            ariaLabel: 'actions_cell',
            renderCell: ({ row, colDef }: { row: ControlRow; colDef: ColumnDefinition }) => (
              <ControlActionCell rowData={row} actions={colDef.actions} />
            ),
            filterOperators: null,
            sortable: false,
          },
        ] as unknown as ColumnDefinition[]
      }
      entity="controls"
      isEntityList
      filters={LIBRARY_NOT_ARCHIVED_FILTERS}
      temporaryFilters={LIBRARY_INCLUDE_ARCHIVED}
      preferencesVersion={2}
      sortBy={{ field: CONTROL_FIELD.name, sort: 'asc' }}
      onError={onError}
      dataURL="/api/entities/controls/"
      fieldsURL="/api/entities/controls/fields/"
      customNoRowsText="No controls have been created yet"
      onRowClick={onRowClick}
      onRefreshCallback={onRefreshCallback}
      disableSelectAllColumns
      testId="controls-grid"
    />
  );
};

export default ControlsTable;
